module.exports = __webpack_public_path__ + "img/logo.23132055.png";